import { Box, Button, Typography } from '@mui/material';
import { FileCheckIcon } from 'components/Icons';
import React from 'react';
import AccountProfile from './AccountProfile';

const VerifyGroupBtn = ({ onOpenVerify, setCertVerify }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
      }}
    >
      <Button
        sx={{
          color: 'white',
          fontWeight: 'bold',
          borderRadius: '32px',
          px: '16px',
          gap: '8px',
          bgcolor: 'transparent',
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'transparent',
          },
        }}
        variant="contained"
        onClick={() => {
          setCertVerify((prev) => ({ ...prev, verifyClaimant: false }));
          onOpenVerify();
        }}
      >
        <FileCheckIcon color="white" />
        <Typography
          fontWeight="bold"
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          Verify Certificate
        </Typography>
      </Button>
      <AccountProfile />
    </Box>
  );
};

export default VerifyGroupBtn;
